export default __webpack_public_path__ + "static/media/messages-chat-with-b2b-buyers-vegshelf-marketplace.6213c7ee.png";